module.exports = __webpack_public_path__ + "img/payon-sm.6f3bfd0e.svg";